module.exports = __webpack_public_path__ + "img/tang-img2.675d1db0.png";